// Talks to the HustlrMate Shield browser extension. The extension injects a small bridge into
// this site's pages only; messages go through window.postMessage and nowhere else.
const FROM_PAGE = "hustlrmate-web";
const FROM_SHIELD = "hustlrmate-shield";

export const SHIELD_DOWNLOAD = "/downloads/hustlrmate-shield.zip";
// Set once the extension is listed in a browser store; until then the page offers the download.
export const SHIELD_STORE_URL = process.env.REACT_APP_SHIELD_STORE_URL?.trim() || "";

let nextId = 1;

// Resolves with the extension's reply, or with { installed: false } when nothing answers.
export function askShield(type, payload = {}, timeout = 1500) {
  return new Promise((resolve) => {
    const id = nextId++;
    const done = (value) => { window.removeEventListener("message", listen); clearTimeout(timer); resolve(value); };
    const listen = (event) => {
      if (event.source !== window || event.origin !== window.location.origin) return;
      const message = event.data;
      if (message?.source === FROM_SHIELD && message.id === id) done(message);
    };
    const timer = setTimeout(() => done({ ok: false, installed: false }), timeout);
    window.addEventListener("message", listen);
    window.postMessage({ source: FROM_PAGE, id, type, ...payload }, window.location.origin);
  });
}

// Calls back when the extension's bridge announces itself (it can load after the page does).
export function onShieldReady(callback) {
  const listen = (event) => {
    if (event.source === window && event.data?.source === FROM_SHIELD && event.data.type === "ready") callback();
  };
  window.addEventListener("message", listen);
  return () => window.removeEventListener("message", listen);
}

export function localDay(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export function duration(seconds) {
  const minutes = Math.round(seconds / 60);
  if (seconds > 0 && minutes < 1) return "<1 min";
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  return minutes % 60 ? `${hours} h ${minutes % 60} min` : `${hours} h`;
}

export function browserLabel() {
  const agent = navigator.userAgent;
  const browser = /Edg\//.test(agent) ? "Edge" : /OPR\//.test(agent) ? "Opera" : /Firefox\//.test(agent) ? "Firefox" : /Chrome\//.test(agent) ? "Chrome" : "Browser";
  const system = /Windows/.test(agent) ? "Windows" : /Mac OS X/.test(agent) ? "Mac" : /Android/.test(agent) ? "Android" : /Linux/.test(agent) ? "Linux" : "";
  return system ? `${browser} on ${system}` : browser;
}
